export default "__VITE_ASSET__DVoQmP9O__"